import React from "react"
import { batch } from "@preact/signals-react"

import { AppButtonIcon, AppSitesAutocomplete, AppToggleButton } from "@components"
import { Box, Grid } from "@mui/material"
import { offices, reports } from "@signals"


export default function AnalyzerPricesChartActions(
	{
		onChange,
		showByPrice,
		handleIsLoading,
		hasSeriesDiff,
		onFilterSites,
		sitesSelected,
		isRating,
		sitesFilterOptions,
		setIsVisible,
		toggleFullScreen,
	}) {

	const TABS = [
		{ label: 'Price values', value: 'price' },
		{ label: 'Variation (%)', value: 'diff', disabled: !hasSeriesDiff },
	]
	const handleButtonClick = (_, newValue) => batch(() => {
		handleIsLoading(true)
		setTimeout(() => {
			handleIsLoading(false)
		}, 100)
		onChange(newValue)
	})

	return <Grid container alignItems="center" justifyContent="center" spacing={1}>
		<Grid item xs={5} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
			<Box sx={{ width: 200, height: 70 }}>
				{!!isRating && <AppSitesAutocomplete
					multiple={false}
					options={sitesFilterOptions}
					sx={{ width: 200, height: 70, my: 2.15 }}
					value={sitesSelected}
					onChange={(_, a) => onFilterSites(a)}
					filters={{
						selected: sitesFilterOptions[0].value,
						officePickupID: offices.value,
						reportExecutionID: reports.value,
					}}
				/>}
			</Box>
		</Grid>
		<Grid item xs={5} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
			<AppToggleButton
				buttonProps={{
					sx: { p: 1 }
				}}
				tabs={TABS}
				value={showByPrice}
				onChange={handleButtonClick}
			/>
		</Grid>
		<Grid item xs={1}>
			<AppButtonIcon
				sx={{ mr: 4 }}
				iconProps={{ iconWeight: "solid" }}
				tooltip="Show/Hide Legend"
				icon={"eye-slash"}
				onClick={() => {
					handleIsLoading(true)
					setTimeout(() => {
						handleIsLoading(false)
					}, 100)
					setIsVisible()
				}}
			/>
		</Grid>
		<Grid item xs={1}>
			<AppButtonIcon
				sx={{ mr: 4 }}
				iconProps={{ iconWeight: "solid" }}
				tooltip="Fullscreen"
				data-tour-id="tour-chart-fullscreen"
				icon={"expand-wide"}
				onClick={() => {
					toggleFullScreen()
				}}
			/>
		</Grid>
	</Grid>


}